<template>
  <div class="about">
    <DashHeader />
    <div class="page">
      <h1>About Our Polling Data</h1>
      <h2>538 pollster ratings</h2>

      <p>There are innumerable polling firms out there. Many of them are terrible, a lot of them are meh, and few of are really great. The folks at FiveThirtyEight.com have methodically looked at the track record of all the major pollsters and graded them on 1) how well they’ve actually predicted elections and 2) the rigor of their statistical methods and given them letter grades “A+” to “F.”</p>

      <p>The polling data for the Electoral College and for the race for control of the Senate used here are bases solely on results from pollsters who have received a “B-” or better grade from FiveThirtyEight.</p>

      <p>(The Daily SnapSHOT polling data for the national popular vote, Trump’s approval/disapproval numbers and the generic ballot are the numbers from the FiveThirtyEight weighted average for that data which takes into account the pollsters’ grades along with recency, sample size and partisan lean.)</p>

      <h2>How the Electoral College SNAPshot is Determined</h2>
      <p>The Electoral College snapshot shows what the Electoral College result would be if the election were held today, based on the most recent state level polling from pollsters who’ve received a “B-” or better grade from FiveThirtyEight.com. States without recent polling, typically states that are infrequently polled because they’re not expected to be competitive are rated based on how they voted in the last presidential election as either “Biden 10+” (e.g., Hawaii) or “Trump 10+” (e.g., Alabama).</p>
      <p>
        <router-link class="page_nav_button" to="/">Back Dashboard</router-link>
      </p>
    </div>
  </div>
</template>
<script>
import DashHeader from "@/components/DashHeader.vue";
export default {
  name: "AboutBettingMarkets",
  components: {
    DashHeader
  }
};
</script>
